import classNames from 'classnames';
import React from 'react';

export type ButtonProps = {
  children?: React.ReactNode;
  primary?: boolean;
  secondary?: boolean;
  textOnly?: boolean;
  tertiary?: boolean;
  small?: boolean;
  medium?: boolean;
  paddingMd?: boolean;
  fullWidth?: boolean;
  alt?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
};

const Button: React.FC<ButtonProps> = ({
  children,
  fullWidth,
  primary,
  secondary,
  tertiary,
  textOnly,
  small,
  medium,
  paddingMd,
  type,
  alt,
  className,
  ...props
}) => {
  const {} = props;
  const cl = classNames({
    button: true,
    'button--primary': primary === true && !alt,
    'button--tertiary': tertiary === true,
    'button--small': small === true,
    'button--medium': medium === true,
    'button--secondary': secondary === true && !alt,
    'button--text-only': textOnly === true,
    'button--padding-md': paddingMd === true,
    'button--primary-alt': alt === true && primary,
    'button--secondary-alt': alt === true && secondary,
    'button--full-width': fullWidth === true,
    [className || '']: true,
  });

  return (
    <button type={type} className={cl} {...props}>
      {children}
    </button>
  );
};
export default Button;
